export default {
  app: {
    name: "W4D",
    full: "W4D Back Office",
    minimized: "BO"
  },
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  relogin: "Please re-login to your account again.",
  expired: "Session Expired!",
  denied: "Permission Denied!",
  success: "You have successfully completed!",
  search_by_id_name: "Search by ID or Name",
  search_by_name: "Search by Name",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"?",
  successful_change_password: "You have successfully change password.",

  drop_down_list_hint: " * Mininum 1 Characters To Trigger Filtering...",
  company_list_no_result: "No Results In This Company Drop Dwon List",
  table_no_result: "No Result In This Table List",
  search_no_result: "The Filter Did Not Uncover Any Results. Please Try To Search Again...",
  delete_information: "Are you sure that you want to delete the following items?",
  match_date_no_result: "There is no result on this match date ({fname}). Please try to search for another date.",
  company_list_select: "Please Select A Company Name From The Company Drop Down List Before Adding.",
  bet_list_no_result: "There is no result for Match Date ({fname}) and Company Name ({fname2}). Please try again...",
  export_excel_no_result: "Browser Denied File Download..."
};
